import React, { useEffect, useState } from 'react';
import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Heading,
    useColorModeValue,
    Spinner,
    Text,
} from '@chakra-ui/react';
import AnalyticsApi from '../../../../api/analytics';
import { prettifyTransferDate } from '../../../../functions/dateUtils';

const BlockedUsersTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const textColor = useColorModeValue('gray.800', 'white');
    const tableBg = useColorModeValue('white', 'gray.700');

    useEffect(() => {
        AnalyticsApi.getBlockedUsers()
            .then((response) => {
                setData(Array.isArray(response.data) ? response.data : []);
                setError(null);
                setLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching blocked users:', err);
                setData([]);
                setError(err?.response?.status ? `שגיאה בטעינת הנתונים (${err.response.status})` : 'שגיאה בטעינת הנתונים');
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <Box
                p="6"
                boxShadow="lg"
                bg={tableBg}
                borderRadius="md"
                w="full"
                textAlign="center"
            >
                <Spinner size="xl" />
                <Text mt="4">טוען משתמשים חסומים...</Text>
            </Box>
        );
    }

    return (
        <Box
            p="6"
            boxShadow="lg"
            bg={tableBg}
            borderRadius="md"
            w="full"
        >
            <Heading size="md" mb="4" color={textColor}>
                משתמשים חסומים
            </Heading>
            <Table variant="simple" size="md">
                <Thead>
                    <Tr>
                        <Th color={textColor}>#</Th>
                        <Th color={textColor}>שם משתמש</Th>
                        <Th color={textColor}>טלפון</Th>
                        <Th color={textColor}>תאריך יצירה</Th>
                        <Th color={textColor}>סיבה</Th>
                        <Th color={textColor}>ת.ז.</Th>
                        <Th color={textColor}>חברה</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {data.length > 0 ? (
                        data.map((row, index) => (
                            <Tr key={`${row.phoneNumber ?? ''}-${row.createdAt ?? index}`}>
                                <Td>{index + 1}</Td>
                                <Td>{row.username ?? '-'}</Td>
                                <Td>{row.phoneNumber ?? '-'}</Td>
                                <Td>{row.createdAt ? prettifyTransferDate(row.createdAt) : '-'}</Td>
                                <Td>{row.reason ?? '-'}</Td>
                                <Td>{row.govId ?? '-'}</Td>
                                <Td>{row.companyId != null ? row.companyId : '-'}</Td>
                            </Tr>
                        ))
                    ) : (
                        <Tr>
                            <Td colSpan={7} textAlign="center">
                                {error ? error : 'לא נמצאו משתמשים חסומים.'}
                            </Td>
                        </Tr>
                    )}
                </Tbody>
            </Table>
        </Box>
    );
};

export default BlockedUsersTable;
